import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import MonthDropdown from '../../../Misc/MonthDropdown';
import {_addNotification, _addNotificationError, getSchoolGrades, groupBy,
    getGradeNumberByText,convertTwoDecimalPoint, gradeNoToText} from "../../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Doughnut,Bar} from 'react-chartjs-2';
import { BASE_URL_1, currency_symbol } from '../../../../server/constants';
var _ = require('lodash');
var converter = require('number-to-words');
const options={
    responsive: true,
    maintainAspectRatio: false,
    legend:{
        position:'top'
    },
    plugins: {
      datalabels: {
         display: 'true',
		 align:'top',
         color:'#000',
         font: { size: '10',weight: 'bold' },
         formatter: function(value, context) {
            return currency_symbol()+''+convertTwoDecimalPoint(context.chart.data.datasets[0].data[context.dataIndex]);
        }
      }
   },
    tooltips: {
        mode: 'label',
        callbacks: {
        label: function(tooltipItem, data) {
            return data.labels[tooltipItem.index] + ": " +currency_symbol()+''+ convertTwoDecimalPoint(data.datasets[0].data[tooltipItem.index]);            
        }
        }
    }
}
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
let gradeList=[];
class BalAmtByGrade extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            currentIndex:0,
            schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList')),
           chartObj: {
                labels: [],
                datasets: [{
                    label: 'Balance Amount',
                    data: [],
                    backgroundColor: 'rgb(54, 162, 235)',
                    borderWidth: 0,
                    hoverBackgroundColor: 'rgb(54, 162, 235)'
                }]
            } 
        }
        
        this.initCurrentIndex=this.initCurrentIndex.bind(this);
        this.onChangeSchoolYear=this.onChangeSchoolYear.bind(this);
        this.getOrdersData=this.getOrdersData.bind(this);
    }
    componentWillMount=()=>{
        this.initCurrentIndex();
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.props.schoolYear!=''){ 
            this.setState({schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList'))},()=>{
                this.initCurrentIndex(); 
            })
        }
    }
    initCurrentIndex=()=>{
        let stateObj=this.state;
        let index= _.findIndex(stateObj.schoolYearList, function(sYear) { return sYear.schoolYear == sessionStorage.getItem('schoolYearValue') });
        this.setState({currentIndex:index},()=>{
         this.onChangeSchoolYear();
        });
    }
    onChangeSchoolYear=()=>{        
        this.getOrdersData();
    }    
    getOrdersData=()=>{
        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
        if(currentSession!=undefined){
            let yearMonth=currentSession.schoolYear;
        get('/dashboard/balanceByGrade?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&yearMonth=' + yearMonth + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj;
            _chartObj.labels=[];
            _chartObj.datasets[0].data=[];
            //let _totalAmount=0.00
            //let _totalStudents=0
            const gradeGroup=groupBy(gradeList,'value');
            (gradeList||[]).forEach(rec=>{
                const key=rec.value;
                if(((orders[key]||{}).totalAmount||0.00)!=0.00){
                    const label=((gradeGroup[key]||[])[0]||{}).label;
                    _chartObj.labels.push(label);
                    _chartObj.datasets[0].data.push(orders[key].totalAmount);
                }
            });
            this.setState({ lineChart:_chartObj,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
        }
    }
    
    render(){ 
        gradeList=getSchoolGrades(0,false);
        let schoolSessionYear= this.state.schoolYearList==null?'':
        (this.state.schoolYearList[this.state.currentIndex==-1?0: this.state.currentIndex].name)      
        return(<div>
         <NotificationSystem ref="notificationSystem"/> 
         <div className="col-md-4">  
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>   
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                 <span className="panel-title" 
                style={{fontSize: '14px', fontWeight:'600'}}>
                 {'Available Balance Amount' }</span>
                <div className="pull-right">
                {
                    this.state.currentIndex>0?<a href='javascript:void(0)'  className="btn-lt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex-1)<0?0:(cIndex-1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }}><i className='fa fa-chevron-circle-left '></i></a>: <a className="btn-lt" disabled="disabled"><i className='fa fa-chevron-circle-left '></i></a>
                }
                {
                    this.state.currentIndex<(this.state.schoolYearList==null?[]:this.state.schoolYearList).length-1?<a href='javascript:void(0)' className="btn-gt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex+1)>this.state.schoolYearList.length-1?this.state.schoolYearList.length-1:(cIndex+1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }} ><i className='fa fa-chevron-circle-right'></i></a>:<a className="btn-gt" disabled="disabled"><i className='fa fa-chevron-circle-right'></i></a>
                }   
                </div>
                <p className="panel-title" 
                style={{fontSize: '12px', fontWeight:'600'}}>
                 {'[School Year: '+schoolSessionYear +']' }</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>                  
                <Bar data={this.state.chartObj} options={options} onElementsClick={elems => {
                     if(elems.length>0){
                        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
                        if(currentSession!=undefined){
                            const gradeGroup=groupBy(gradeList,'label');
                            let schoolYear=currentSession.schoolYear;
                            console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);
                            const gradeValue=((gradeGroup[elems[0]._model.label]||[])[0]||{}).value;                              
                            let action='all';
                            this.props.onElementClick(gradeValue,action,schoolYear)
                        }
                     }
                }} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default BalAmtByGrade


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/BalAmtByGrade.jsx